import { LicenseManager } from '../../../../managers/License.manager';
import { LiveHubService } from './../../../../services/livehub.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { clientFilesFilter } from '../../../../pipes/filter.pipe';
import { ssApiService } from '../../../../services/ss-api.service';
import { GlobalService } from '@services/global.service';
import { FileUploadItemArray } from '@models/domain/file.upload.item';
import { Subscription } from 'rxjs';

@Component({
    selector: 'license-cloud-manager',
    templateUrl: './license.cloud.manager.component.html',
    styleUrls: ['./license.cloud.manager.component.scss']
})
export class LicenseCloudManagerComponent implements OnInit, OnDestroy {
    IsBusy: boolean = false;

    @Input('licenseManager') licenseManager: LicenseManager;
    @Input('Subscriptions') Subscriptions;

    // File Browser
    UploadedFiles: FileUploadItemArray;
    UpdateManagerFiles: Array<DownloadDisplay> = new Array<DownloadDisplay>();

    FileProgressSubscription: Subscription;
    UploadFileSystemSubscription: Subscription;

    constructor(private liveHub: LiveHubService, private sweetAlert: SweetAlertService, private clientFilesFilter: clientFilesFilter, private api: ssApiService, private gb: GlobalService) { }

    ngOnInit() {
        // this.IsBusy = true;
        this.FileProgressSubscription = this.liveHub.OnFileUploadProgress.subscribe(data =>             
            {
                var currentEntry = this.UpdateManagerFiles.find((o) => { return o["FileName"] === data.FileName });
                if (currentEntry == undefined){

                    //console log
                    console.log("Progress Received, adding to list ---------------------");
                    console.log("FileName: " + data.FileName);
                    console.log("Speed: " + data.SpeedPerSecondBytesFormatted);
                    console.log("Percentage: " + data.PercentageFormatted);
                    console.log("Estimated Time Left Display: " + data.EstimatedTimeLeftFormatted);
                    console.log("Estimated Time Left: " + data.EstimatedTimeLeft);
                    console.log("Total Size: " + data.TotalSizeFormatted);
                    console.log("Total Transfered: " + data.ProcessedSizeFormatted);

                    //add to list
                    var newEntry = new DownloadDisplay();
                    newEntry.FileName = data.FileName;
                    newEntry.DownloadSpeedDisplay = data.SpeedPerSecondBytesFormatted;
                    newEntry.FileSizeDisplay = data.TotalSizeFormatted;
                    newEntry.EstimatedTimeLeftDisplay = data.EstimatedTimeLeftFormatted;
                    newEntry.Progress = data.Percentage;
                    this.UpdateManagerFiles.push(newEntry);
                }
                else{
                    currentEntry.Progress = data.Percentage;
                    currentEntry.DownloadSpeedDisplay = data.SpeedPerSecondBytesFormatted;
                    currentEntry.EstimatedTimeLeftDisplay = data.EstimatedTimeLeftFormatted;
                }
            });

        this.UploadFileSystemSubscription =  this.liveHub.UploadFileSystemResponse.subscribe(data =>
            {
                this.UpdateManagerFiles = this.UpdateManagerFiles.filter(x => x.FileName != data.RequestedPath);
                this.GetPreviouslyUploadedFiles();
            });
            
        this.GetPreviouslyUploadedFiles();
    }

    ngOnDestroy(){        
        if (this.UploadFileSystemSubscription != null)
            this.UploadFileSystemSubscription.unsubscribe();
    }
   
    GetPreviouslyUploadedFiles() {
        //this.IsFilesBusy = true;
        let disposable = this.api.FileUploadsByMember(this.licenseManager.License().MemberID).subscribe(response => {
            //this.IsFilesBusy = false;
            if (response.Result) {
                console.log("rd", response.Data);
                this.UploadedFiles = new FileUploadItemArray();
                response.Data.forEach(function(file) {
                    if (file.LicenseKey == this.licenseManager.License().Key && file.DownloadURL != "") {
                        this.UploadedFiles.push(file);
                    }
                }, this);
                console.log("tuf", this.UploadedFiles);
            }
            disposable.unsubscribe();
        });
    } 


    DownloadFile(item) {
        if (item.DownloadURL.length < 1) {
            //Currently in progress
        } else {
            window.open(item.DownloadURL);
        }
    }

    IconForFile(filename) {
        var extension = "." + filename.substr( (filename.lastIndexOf('.') +1) );
        switch (extension) {
            case '.zip':
                return 'fa-file-zip-o';
            case '.pdf':
                return 'fa-file-pdf-o';
            case '.jpg':
            case '.jpeg':
            case '.png':
            case '.gif':
            case '.svg':
            case '.tiff':
                return 'fa-file-image-o';
            case '.mp3':
            case '.wav':
            case '.aac':
                return 'fa-file-sound-o';
            case '.mp4':
            case '.avi':
            case '.mkv':
                return 'fa-file-video-o';
            case '.dat':
            case '.config':
            case '.pdb':
            case '.ini':
            case '.xml':
                return 'fa-file-code-o';
            case '.exe':
                return 'fa-file';
            case '.txt':
                return 'fa-file-text-o';
            default:
                return 'fa-file-o';
        }
    }


}
export class DownloadDisplay {
    FileName: string;
    FileSizeDisplay: string;
    Progress: number;
    DownloadSpeedDisplay: string;
    EstimatedTimeLeftDisplay: string;
}
